import styled from 'styled-components'

export const FormsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  width: 100%;
`

export const Title = styled.h1`
  font-family: Poppins;
  font-weight: 600;
  font-size: inherit;
  color: #00607f;
  margin-bottom: 2rem;
  font-size: 2rem;
`
